<template>
   <van-cell title="社保+（）组合下单折扣：2020.2.1~2021.12.31">
        <template slot="label">
          <div>
            <van-tag plain type="danger">满减</van-tag> 加一个项目服务费立减<span class="text-red"><b>50元</b></span>/按月/按半年～<span class="text-red"><b>100元</b></span>/按年
          </div>
          <div style="margin-top:5px;">
            <van-tag plain type="danger">折扣</van-tag> 加公积金，公积金服务费打<span class="text-red"><b>6折</b></span>/按半年/按年
          </div>
            <div style="margin-top:5px;">
            <van-tag plain type="danger">抹零</van-tag> 满减和折扣基础上服务费再取整<span class="text-red"><b>抹零</b></span>
          </div>
        </template>
      </van-cell>
</template>

<script>
import _ from "lodash";
import { Toast, version , Dialog} from "vant";

export default {
  name: "sby-discount-tips",
  props: {
   
  },
  model: {
   
  },
  data() {
    return {
      
    };
  },
  mounted() {},
  watch: {
   
  },
  methods: {
  
  }
};
</script>




// WEBPACK FOOTER //
// src/components/sby-discount-tips.vue